var _defs, _rect, _line, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5C77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#C8A55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C7E3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldSoft",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5C77D",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C8A55B",
    stopOpacity: 0.06
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 118,
    width: 124,
    height: 52,
    rx: 10,
    fill: "url(#goldSoft)",
    stroke: "url(#gold)",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 142,
    x2: 162,
    y2: 142,
    stroke: "url(#gold)",
    strokeWidth: 1,
    strokeOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 150,
    width: 36,
    height: 3,
    rx: 1.5,
    fill: "url(#gold)",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 150,
    width: 24,
    height: 3,
    rx: 1.5,
    fill: "url(#gold)",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 130 L28 142 L38 142",
    stroke: "url(#gold)",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162 130 L172 142 L162 142",
    stroke: "url(#gold)",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96 L140 64 L118 108 Z",
    fill: "url(#goldSoft)",
    stroke: "url(#gold)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96 L100 88 L118 108",
    stroke: "url(#gold)",
    strokeWidth: 1,
    strokeLinejoin: "round",
    fill: "none",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100 88 L140 64",
    stroke: "url(#gold)",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeDasharray: "3 2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 102,
    r: 2,
    fill: "url(#gold)",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 108,
    r: 1.5,
    fill: "url(#gold)",
    fillOpacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 113,
    r: 1,
    fill: "url(#gold)",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 68,
    width: 44,
    height: 32,
    rx: 5,
    fill: "none",
    stroke: "url(#gold)",
    strokeWidth: 1.5,
    strokeOpacity: 0.25,
    strokeDasharray: "4 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLeads);
export default __webpack_public_path__ + "static/media/empty-leads.995520cc77a7c32b24745930da6669f7.svg";
export { ForwardRef as ReactComponent };